// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f0c57b30","703":"3997b002","787":"feef3d31"}[chunkId] + ".chunk.js";
};